import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataCareerCertificationSchema = validator.object().shape({
  certificationName: validator.string().emptyToNull().label("技能水準名（日本語）").required(),
  careerCertificationRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(2)
    .label("期間更新CSVのコード")
    .required(),
});
